import React from "react";

import { Box, Center, Overlay, Stack, Text } from "@mantine/core";

import Logo from "modules/core/assets/img/efestra-logo-small.png";

import classes from "./styles.module.css";

interface IProps {
  fullScreen?: boolean;
  fullWidth?: boolean;
  height?: number;
  label?: string;
}

const Spinner = ({ label }: { label: string }) => (
  <Center w="100%" h="100%" bg="white">
    <Stack align="center">
      <img src={Logo} alt="Efestra" className={classes.logo} />

      <Text fz="xs" fw={500} c="dimmed">
        {label}
      </Text>
    </Stack>
  </Center>
);

const LoadingSpinner: React.FC<IProps> = props => {
  const { fullScreen, fullWidth, height, label = "Loading..." } = props;

  if (fullScreen) {
    return (
      <Overlay bg="white">
        <Spinner label={label} />
      </Overlay>
    );
  }

  if (fullWidth) {
    return (
      <Box w="100%" h={height || "100%"} bg="white">
        <Spinner label={label} />
      </Box>
    );
  }

  return <Spinner label={label} />;
};

export default LoadingSpinner;
